var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 48 48 48 48 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook-logo",
    transform: "translate(40, 36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1279-Clipped",
    transform: "translate(24, 24) scale(-1, 1) rotate(-180) translate(-24, -24)translate(0, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path1281"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1279",
    mask: "url(#mask-2)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.7031, 0.7031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.59375,23.296875 C46.59375,36.1634063 36.1634063,46.59375 23.296875,46.59375 C10.4303438,46.59375 0,36.1634063 0,23.296875 C0,10.4303438 10.4303438,0 23.296875,0 C36.1634063,0 46.59375,10.4303438 46.59375,23.296875 Z",
    id: "path1287",
    stroke: "#37474F",
    strokeWidth: 1.39999997
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1289",
    transform: "translate(13.5272, 3.7575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5271875,22.545375 L13.5271875,25.551375 C13.5271875,26.7965625 14.5365937,27.8059688 15.7816875,27.8059688 L18.7877812,27.8059688 C19.2028125,27.8059688 19.5392812,28.1424375 19.5392812,28.5574688 L19.5392812,33.0665625 C19.5392812,33.4815938 19.2028125,33.8180625 18.7877812,33.8180625 L14.2786875,33.8180625 C9.71315625,33.8180625 6.01209375,30.117 6.01209375,25.551375 L6.01209375,19.539375 L0.7515,19.539375 C0.33646875,19.539375 -1.63106282e-14,19.2029063 -1.63106282e-14,18.7877813 L-1.63106282e-14,14.2787813 C-1.63106282e-14,13.86375 0.33646875,13.5272813 0.7515,13.5272813 L6.01209375,13.5272813 L6.01209375,0",
    id: "path1291",
    stroke: "#37474F",
    strokeWidth: 1.39999997
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1293",
    transform: "translate(27.0544, 0.7515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,16.5332813 L3.9223125,16.5332813 C4.26721875,16.5332813 4.56778125,16.7679375 4.65140625,17.1025313 L5.77865625,21.6115313 C5.89725,22.0859063 5.53846875,22.545375 5.0495625,22.545375 L0,22.545375",
    id: "path1295",
    stroke: "#37474F",
    strokeWidth: 1.39999997
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.2144a9df4c7655c1455bad1e29aaf5ed.svg";
export { ForwardRef as ReactComponent };